import {    PROCESS_REQUESTED,
    PROCESS_RECEIVED,
    PROCESS_ERROR,

    } from "../actions/bpmnProcess";
import RequestState from "../storage/RequestState";
import RequestResult from "../storage/RequestResult";
import {EMPTY_REQUEST_RESULT_INIT_STATE} from "../utils/JsObjectHelper";

/**
*
* @param {RequestResult} state
* @param {BaseAction|ReceiveEntryTypesAction|ReceiveErrorAction} action
* @return {RequestResult}
*/
export const process = (state = EMPTY_REQUEST_RESULT_INIT_STATE, action)  => {

switch (action.type) {
   case  PROCESS_REQUESTED:
       return new RequestResult(RequestState.getInstanceLoading(), state.data);
   case  PROCESS_RECEIVED:
       return new RequestResult(RequestState.getInstanceDone(), action.process, action.receivedAt);
   case  PROCESS_ERROR:
       return new RequestResult(
           RequestState.getInstanceError(
               action.errorResponseStatusCode,
               action.errorResponseMessage ? action.errorResponseMessage : null
           ),
           state.getData()
       );
 
   default:
       return state
}
};
